import { type ReactNode } from 'react'
import { Stack } from '@mantine/core'
import { useTranslation } from '@front/model'
import { TCard } from '@components'
import { ToggleRow } from './ToggleRow'
import { type CompanyCardFormProps } from './CompanyCardFields'

export const ContentFields = ({ form }: CompanyCardFormProps): ReactNode => {
  const { t } = useTranslation()

  return (
    <TCard>
      <Stack gap='lg'>
        <TCard.Header>
          <TCard.Title>{t('Card content')}</TCard.Title>
        </TCard.Header>
        <ToggleRow
          checked={form.values.sections?.trust ?? true}
          description={t('Tenure and service area shown on the banner.')}
          label={t('Trust chips')}
          onChange={(checked) => form.setFieldValue('sections.trust', checked)}
        />
      </Stack>
    </TCard>
  )
}
